import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const useGetUrlParams = (params) => {
    const location = useLocation();
    const [data, setData] = useState(null);

    useEffect(() => {
        // Read from the react-router location (kept in sync with the address bar)
        // and re-read whenever the query string changes. Previously this only ran
        // once per mount, so client-side navigation (e.g. homepage -> /search)
        // left the form fields showing stale/empty values until a full page load.
        const queryString = location.search || window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const paramsCapital = capitalizeFirstLetter(params);
        const resList = urlParams.getAll(paramsCapital) || urlParams.getAll(params);
        const res = urlParams.get(paramsCapital) || urlParams.get(params);

        setData(resList.length > 1 ? resList : res || '');
    }, [params, location.search]);

    return [data];
};

export default useGetUrlParams;
 

